export default __webpack_public_path__ + "static/project-slide-2-1640-765-46719a76015e6be3323139290f9fd1ba.webp";